import { Modal as BaseModal } from 'components';
import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  max-width: 1068px;
  margin: 0 auto;
  width: 100%;
`;

export const GuideContentWrapper = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  width: 100%;
`;

export const GuideStepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const GuideStep = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  align-items: center;
  gap: 32px;
  padding: 28px 0;
  border-bottom: 1px solid #e9ecef;

  &:last-child {
    border-bottom: 0;
  }

  ${({ $isReversed }) =>
    $isReversed &&
    css`
      grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    `}

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 24px 0;
  }
`;

export const GuideStepText = styled.div`
  min-width: 0;
  order: ${({ $isReversed }) => ($isReversed ? 2 : 1)};

  @media (max-width: 767px) {
    order: 1;
  }
`;

export const GuideStepImageWrapper = styled.div`
  order: ${({ $isReversed }) => ($isReversed ? 1 : 2)};
  width: 100%;
  overflow: hidden;
  aspect-ratio: 16 / 10;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #f1f4f6;

  @media (max-width: 767px) {
    order: 2;
  }
`;

export const GuideStepImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: left;
`;

export const GuideStepNumber = styled.span`
  display: inline-flex;
  margin-bottom: 12px;
  color: #be1622;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const GuideStepTitle = styled.h2`
  margin: 0 0 12px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.25;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;

export const GuideStepDescription = styled.p`
  max-width: 560px;
  margin: 0;
  color: #495057;
  font-size: 16px;
  line-height: 1.6;
`;

export const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const PreviewIframe = styled.iframe`
  width: 100%;
  max-width: 1200px;
  overflow: hidden;
`;

export const FooterWrapper = styled.div.attrs({
  className: 'd-flex w-100 justify-content-end',
})`
  button {
    border-radius: 0;
  }
`;

export const TypeSelectorCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1px solid #d3d3d3;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f9f9f9;
  }

  &:focus-visible {
    outline: none;
    border-color: #be1622;
  }
`;

export const TypeSelectorIcon = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
`;

export const TypeSelectorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const TypeSelectorLabel = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: #333;
`;

export const TypeSelectorDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const TypeSelectorPlaceholder = styled.span`
  font-size: 16px;
  color: #999;
`;

export const TypeSelectorChangeHint = styled.span`
  font-size: 13px;
  color: #999;
  margin-left: auto;
  flex-shrink: 0;
`;

export const TypeSelectModal = styled(BaseModal).attrs({
  contentStyle: { maxWidth: '700px' },
  bodyStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: 0,
  },
  wide: true,
})``;

export const TypeSelectModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  width: 100%;
  overflow-y: auto;
`;

export const TypeCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border: 1px solid #d3d3d3;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f9f9f9;
  }

  &:focus-visible {
    outline: none;
    border-color: #be1622;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      border-color: #be1622;
      background: #fff5f6;

      &:hover {
        background: #fff5f6;
      }
    `}
`;

export const TypeCardIcon = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
`;

export const TypeCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TypeCardLabel = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: #333;
`;

export const TypeCardDescription = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
`;

export const SnippetWrapper = styled.div`
  position: relative;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 16px;
  padding-right: 100px;
`;

export const SnippetCode = styled.code`
  display: block;
  font-size: 13px;
  color: #333;
  word-break: break-all;
  white-space: pre-wrap;
`;

export const SnippetCopyButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: white;
  font-size: 13px;
  color: #555;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #e9ecef;
  }
`;
